import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SVG from 'react-inlinesvg';
import { listElementsToArray } from '../../responsibilitiesUtils';
import { validateEmail } from '../../formValidators';
import logoImg from '../../../assets/images/Logo_Gray.svg';
import dollarGreen from '../../../assets/images/icons/dollar-sign-green.svg';
import capitalize from '../../stringUtils';
import { formatCurrency } from '../../numberUtils';
import './ProjectShare.scss';

const renderSkills = (skills, t) => (
  skills.map((s) => (
    <span className={`badge small mr-5 ${t.badge_class} ${s[1] ? 'priority' : ''}`}>
      {s[0]}
      {s[1] ? <strong className="pl-2"><i>*Must have</i></strong> : null }
    </span>
  ))
);

const renderTags = (tags) => (
  tags.map((t) => (
    <div className="tags mt-3  mb-3  project-tags">
      <div className="body-text-3 medium-weight skill-name">{t.skill_name}</div>
      {t.not_applicable
        ? <span className="body-text-3 muted-gray-text">Not Applicable</span>
        : renderSkills(t.skills, t)}
    </div>
  ))
);

const renderQualifications = (qualifications) => (
  qualifications.map((q) => (
    q.list.length
      ? (
        <div className="tags mt-3 mb-3 project-qualifications">
          <div className="body-text-3 medium-weight qualification-name">{q.name}</div>
          <ul className="body-text-3">
            {q.list.map((l) => <li>{l}</li>)}
          </ul>
        </div>
      ) : ''
  ))
);

const renderSkillsQualifications = (qualifications, tags) => [
  <h4 className="highlight-text mt-3">
    SKILLS
  </h4>,
  renderTags(tags),
  (qualifications.map((q) => q.list).every((list) => list.length === 0) ? null : [
    <h4 className="highlight-text mt-3">
      QUALIFICATIONS
    </h4>,
    renderQualifications(qualifications),
  ]),
];

const renderOpportunitiesButton = (notInterestedUrl, customClass) => (
  <a href={notInterestedUrl} className={`btn btn-secondary highlight-text not-interested-project-share ${customClass}`}>
    See all opportunities
  </a>
);

class ProjectShare extends Component {
  constructor(props) {
    super(props);

    this.state = {
      errorMessage: null,
      email: '',
    };
    this.handleValidation = this.handleValidation.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
  }

  handleEmailChange(e) {
    this.setState({ email: e.target.value });
  }

  handleValidation(e) {
    const { email } = this.state;

    const emailValidation = validateEmail(email);
    if (emailValidation.error) {
      e.preventDefault();
      this.setState({ errorMessage: emailValidation.error });
    } else {
      this.setState({ errorMessage: null });
    }
    return null;
  }

  renderApplyButton(customClass = '') {
    const { errorMessage } = this.state;
    const {
      isConsultant, acceptingProposals, submitInterestProjectUrl,
      sourced, csrfToken, email, recommendationId, candidateSource,
    } = this.props;

    if (!acceptingProposals) {
      return (
        <p className="mt-2 mb-2">This project is not accepting proposals at this time.</p>
      );
    } if (isConsultant) {
      return (
        <form
          action={submitInterestProjectUrl}
          acceptCharset="UTF-8"
          method="post"
          className="text-center mt-2 mb-2"
        >
          <input type="hidden" name="authenticity_token" value={csrfToken} />
          <input type="hidden" name="sourced" value={sourced} />
          <button type="submit" className={`btn btn-primary ${customClass} width-100p`} id="project-share-apply-button">
            Apply Now
          </button>
        </form>
      );
    }
    return (
      <form action={submitInterestProjectUrl} acceptCharset="UTF-8" method="post">
        <input type="hidden" name="authenticity_token" value={csrfToken} />
        <input type="hidden" name="recommendation_id" value={recommendationId} />
        <input type="hidden" name="sourced" value={sourced} />
        <input type="hidden" name="candidate_source" value={candidateSource} />
        <label htmlFor="email" className="medium-weight">Enter your email & Apply Now:</label>
        <div className="email-input">
          <input
            type="email"
            name="email"
            id="email"
            className="form-control share-email-input"
            placeholder="Enter your email"
            defaultValue={email}
            required
            onChange={this.handleEmailChange}
          />
          { errorMessage
            ? (
              <div className="error-text">
                { errorMessage }
              </div>
            ) : ''}
        </div>
        <div>
          <input
            type="submit"
            name="commit"
            id="project-share-apply-button"
            className={`btn btn-primary ${customClass}`}
            value="Apply Now"
            onClick={this.handleValidation}
          />
        </div>
      </form>
    );
  }

  render() {
    const {
      name,
      officeAndWorkType,
      workCommitment,
      jobTitles,
      description,
      responsibilities,
      idealCandidateDescription,
      duration,
      startDate,
      travelLocations,
      workLocation,
      acceptingProposals,
      notInterestedUrl,
      rootUrl,
      tags,
      qualifications,
      showProjectEmploymentType,
      employmentType,
      basePayHidden,
      budgetMinimum,
      budgetMaximum,
    } = this.props;

    return (
      <div>
        <div className="project-detail">
          {showProjectEmploymentType && (
          <div className={`${employmentType}-badge`}>
            {capitalize(employmentType)}
            {' '}
            Position
          </div>
          ) }
          <div className="g-row g-flex-justify-space-between project-header">
            <div className="g-flex-7">
              <h1 className="demibold project-name mt-2 mb-2">{name}</h1>
              {acceptingProposals && (
                <h6 className="warning-text mt-0">
                  <i className="fas fa-running" />
                  Opportunity closes soon!
                </h6>
              )}
              <div className="body-text-1">{jobTitles && `Relevant Job Titles(s): ${jobTitles}`}</div>
              <div className="project-description">
                <h4 className="highlight-text mt-25 mb-2">
                  DESCRIPTION
                </h4>
                <p>{description}</p>
              </div>
              <div id="responsibilities" className="mt-4 project-responsibilities">
                <h4 className="demi-bold highlight-text mb-2">
                  RESPONSIBILITIES
                </h4>
                <div className="g-column">
                  <ul className="responsibility_areas">
                    {responsibilities.map((r) => (
                      <li key={r}>{r}</li>
                    ))}
                  </ul>
                </div>
              </div>
              <div id="ideal-candidate-description" className="mt-4 project-ideal-candidate">
                <h4 className="demi-bold highlight-text mb-2">
                  IDEAL CANDIDATE
                </h4>
                <div className="g-column">
                  <ul className="responsibility_areas">
                    {listElementsToArray(idealCandidateDescription).map((r) => (
                      <li key={r}>{r}</li>
                    ))}
                  </ul>
                </div>
              </div>
              {(employmentType === 'full_time' && basePayHidden === false)
                && (
                <div id="annual-base-salary" className="mt-4 annual-base-salary">
                  <span>
                    <SVG src={dollarGreen} alt="Dollar" />
                  </span>
                  <div>
                    <p>
                      Annual base salary range:&nbsp;
                      {formatCurrency(budgetMinimum)}
                      {' '}
                      -
                      {formatCurrency(budgetMaximum)}
                    </p>
                    <p className="disclaimer">
                      Pay may vary outside of this range depending on a number of factors,
                      including but not limited to a candidate’s qualifications,
                      skills, competencies, experience, and location.
                    </p>
                  </div>
                </div>
                )}
            </div>
            <div className="mb-2 g-flex-4 share-email-form d-none d-sm-block">
              { this.renderApplyButton('bigger-button') }
              <h4 className="highlight-text mt-25 mb-2">
                COMMITMENT
              </h4>
              <div className="commitment work-commitment">
                { employmentType === 'full_time'
                  ? (
                    <p>
                      <i className="fas fa-clock" />
                      Full Time
                    </p>
                  )
                  : (
                    <p>
                      <i className="fas fa-clock" />
                      <strong>{`${workCommitment} hrs/week`}</strong>
                      {' '}
                      for
                      <strong>
                        {`${duration} 
                    month duration`}
                      </strong>
                    </p>
                  )}
              </div>
              { workLocation
              && (
              <div className="commitment work-location">
                <p>
                  <i className="fas  fa-map-marker-alt" />
                  {officeAndWorkType}
                </p>
              </div>
              )}
              {startDate && (
              <div className="commitment start-date">
                <p>
                  <i className="fas fa-calendar-day" />
                  {' '}
                  {startDate}
                </p>
              </div>
              )}
              { travelLocations
                ? (
                  <div className="commitment travel">
                    <p>
                      <i className="fas fa-plane" />
                      {`Travel Requirements - ${travelLocations}`}
                    </p>
                  </div>
                ) : ''}
              <div className="tags mb-2 d-none d-nd-block">
                {renderSkillsQualifications(qualifications, tags)}
              </div>
            </div>
          </div>
          <div className="tags my-2 d-flex d-md-none">
            {renderSkillsQualifications(qualifications, tags)}
          </div>
        </div>
        <div className="d-none d-sm-block">
          <div className="text-center">
            <h1 className=" mb-3 ">Not interested in this opportunity?</h1>
            {renderOpportunitiesButton(notInterestedUrl)}
          </div>
        </div>
        <div className="d-block d-sm-none mt-3 mx-3 mb-5">
          <div className="share-email-form">
            { this.renderApplyButton() }
          </div>
          <hr />
          <div className="text-center">
            {renderOpportunitiesButton(notInterestedUrl, 'width-100p')}
          </div>
        </div>

        <div className="project-clora-how-to-apply">
          <h1 className=" mb-3 ">
            Apply now to be 1 of the 3 candidates for this position:
          </h1>
          <div className="g-row g-flex-justify-space-between">
            <div className="g-flex-30 how-to upload-resume">
              <div className="g-row list">
                <div className="demibold me-2">1.</div>
                <div>
                  <div className="demibold mb-5">Upload your resume</div>
                  <p>Apply now to submit your resume to Clora.</p>
                </div>
              </div>
            </div>
            <div className="g-flex-30 how-to submit-proposal">
              <div className="g-row list">
                <div className="demibold me-2">2.</div>
                <div>
                  <div className="demibold mb-5">Answer a few questions</div>
                  <p>Tell the company why you&#39;re a good fit for their needs.</p>
                </div>
              </div>
            </div>
            <div className="g-flex-30 how-to interview">
              <div className="g-row list">
                <div className="demibold me-2">3.</div>
                <div>
                  <div className="demibold mb-5">Interview with the company</div>
                  <p>If selected, Clora will put you in contact with the company.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="about-clora-blurb">
          <a href={rootUrl}>Clora</a>
          &#39;s intelligent
          selection engine finds projects from top life science companies that match your
          experience and skills. All projects are vetted by life science professionals.
          <img src={logoImg} alt="Clora" className="clf-logo-footer" />
        </div>
      </div>
    );
  }
}

ProjectShare.propTypes = {
  name: PropTypes.string.isRequired,
  jobTitles: PropTypes.string,
  workCommitment: PropTypes.number.isRequired,
  officeAndWorkType: PropTypes.string,
  travelLocations: PropTypes.string,
  duration: PropTypes.string.isRequired,
  workLocation: PropTypes.string.isRequired,
  startDate: PropTypes.string.isRequired,
  responsibilities: PropTypes.arrayOf(PropTypes.string).isRequired,
  idealCandidateDescription: PropTypes.arrayOf(PropTypes.string).isRequired,
  description: PropTypes.string.isRequired,
  acceptingProposals: PropTypes.bool.isRequired,
  isConsultant: PropTypes.bool.isRequired,
  submitInterestProjectUrl: PropTypes.string.isRequired,
  sourced: PropTypes.string.isRequired,
  notInterestedUrl: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  email: PropTypes.string,
  rootUrl: PropTypes.string.isRequired,
  recommendationId: PropTypes.number,
  tags: PropTypes.arrayOf(PropTypes.string).isRequired,
  qualifications: PropTypes.arrayOf(PropTypes.string).isRequired,
  candidateSource: PropTypes.string,
  showProjectEmploymentType: PropTypes.bool.isRequired,
  employmentType: PropTypes.string.isRequired,
  budgetMinimum: PropTypes.string.isRequired,
  budgetMaximum: PropTypes.string.isRequired,
  basePayHidden: PropTypes.bool.isRequired,
};

ProjectShare.defaultProps = {
  jobTitles: null,
  email: null,
  candidateSource: null,
};

export default ProjectShare;
